import React, { Component } from 'react'

import PropTypes from 'prop-types'
import moment from 'moment'
import getByPath from 'lodash/get'
import isFunction from 'lodash/isFunction'

import { getPlaceInfoById, getPlaceInfoByAddress } from './../../libs/utils'
import { NotificationManager } from 'react-notifications'

import { Marker } from 'react-google-maps'

import Map from './../TripPlanner/Map'
import Event from './Event'
import Note from './Note'

const google = window.google

export default class TripDate extends Component {
  static propTypes = {
    day: PropTypes.object,
    customizedPlanId: PropTypes.string,
    expand: PropTypes.bool
  }

  static defaultProps = {
    day: {},
    customizedPlanId: ''
  }

  constructor(props) {
    super(props)

    this.state = {
      isOpen: props.expand,
      markers: []
    }
  }

  componentDidMount() {
    if (this.state.markers.length == 0) {
      this.prepareMarkers()
    }
  }

  async prepareMarkers() {
    if (this.state.isOpen) {
      await this.renderMarkers(locations => {
        if (this.map && isFunction(this.map.fitBounds)) {
          const bounds = new google.maps.LatLngBounds()

          locations.forEach(location => {
            bounds.extend(new google.maps.LatLng(location.geometry.location.lat(), location.geometry.location.lng()))
          })

          this.map.fitBounds(bounds)
        }
      })
    }
  }

  onTitleClick() {
    const events = getByPath(this.props, 'day.eventItineraryDays', [])

    if (!events.length) return

    this.setState(
      {
        isOpen: !this.state.isOpen
      }, this.prepareMarkers
    )
  }

  renderTitle() {
    let title = ''

    if (this.props.day.dayoftrip) {
      // This is the ref timezone used for the times and dates
      let originalTz = 'Asia/Jerusalem'
      title += `${moment(this.props.day.dayoftrip).tz(originalTz).format('MMM D')}, `
    }

    title += this.props.day.title

    return title
  }

  async renderMarkers(cb) {
    const events = getByPath(this.props, 'day.eventItineraryDays', [])
    const promises = []

    events.forEach(event => {
      if (['CarRental', 'Train', 'Transportation'].indexOf(event.ContentEvent.type) !== -1) {
        const departure = getByPath(event.ContentEvent, 'EventDetails.TransportationDetail.departure')
        const arrival = getByPath(event.ContentEvent, 'EventDetails.TransportationDetail.arrival')

        if (departure) {
          promises.push(getPlaceInfoByAddress(departure))
        }

        if (arrival) {
          promises.push(getPlaceInfoByAddress(arrival))
        }
      } else if (['Activity', 'Info', 'Lodging'].indexOf(event.ContentEvent.type) !== -1) {
        const googleId = getByPath(event.ContentEvent, 'eventPois[0].contentPOI.place.googleId')

        if (googleId) {
          promises.push(getPlaceInfoById(googleId))
        }
      } else if (event.type === 'Flight') {
        const departure = getByPath(event.ContentEvent, 'EventDetails.FlightDetail.departureAirport.apiid')
        const arrival = getByPath(event.ContentEvent, 'EventDetails.FlightDetail.arrivalAirport.apiid')

        if (departure) {
          promises.push(getPlaceInfoById(departure))
        }

        if (arrival) {
          promises.push(getPlaceInfoById(arrival))
        }
      }
    })

    try {
      const locations = await Promise.all(promises)

      const finalLocations = locations.filter((location) => {
          return location && location.geometry
      })

      this.setState(
        () => ({
          markers: finalLocations.map((location, i) => {
            return <Marker
              key={i}
              position={{
                lat: location.geometry.location.lat(),
                lng: location.geometry.location.lng()
              }}
            />
          })
        }),
        () => {
          if (isFunction(cb)) {
            cb(finalLocations)
          }
        }
      )
    } catch (err) {
      NotificationManager.error(err.message, 'Error', 5000)
    }
  }

  renderData() {
    const events = getByPath(this.props, 'day.eventItineraryDays', [])
    const notes = getByPath(this.props, 'day.ItinerarydayNotes', [])

    return (
      <div className="trip-date__events">
        { !this.props.expand &&
        <Map
          containerElement={<div className="google-map__container" />}
          mapElement={<div className="google-map__element" />}
          markers={this.state.markers}
          createRef={map => {
            this.map = map
          }}
        />
        }

        {notes.map((note, i) => <Note key={i} data={note} customizedPlanId={this.props.customizedPlanId} user={this.props.user} />)}
        {events.map((event, i) => <Event key={i} data={event.ContentEvent} customizedPlanId={this.props.customizedPlanId} user={this.props.user} />)}
      </div>
    )
  }

  render() {
    return (
      <div className="trip-date">
        <div
          className="trip-date__title"
          onClick={() => {
            this.onTitleClick()
          }}
        >
          {this.renderTitle()}
        </div>

        <hr />

        {this.state.isOpen && this.renderData()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/components/MyTrip/TripDate.js